(() => {
  if (window.kuzuCountdownLoaded) return;
  window.kuzuCountdownLoaded = true;
  const active = new Map();
  const parseTarget = (value) => {
    if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(Z|[+-]\d{2}:\d{2})$/.test(value)) return NaN;
    return Date.parse(value);
  };
  const initialize = (scope = document) => scope.querySelectorAll('[data-kuzu-countdown]').forEach((root) => {
    if (active.has(root)) return;
    const target = parseTarget(root.dataset.launchAt || '');
    const digits = root.querySelector('[data-countdown-digits]');
    const status = root.querySelector('[data-countdown-status]');
    const summary = root.querySelector('[data-countdown-summary]');
    if (!Number.isFinite(target)) {
      status.textContent = 'Launch timing is being confirmed. Subscribe for updates.';
      digits.hidden = true;
      return;
    }
    // Generate the visible date from the same instant as the timer to prevent drift.
    const label = new Intl.DateTimeFormat('en-GB', {timeZone:'Asia/Thimphu',day:'numeric',month:'long',year:'numeric',hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).format(target);
    root.querySelector('[data-launch-label]').textContent = `${label} Bhutan time (UTC+6)`;
    let lastMinute = -1;
    let interval;
    const tick = () => {
      if (!root.isConnected) { clearInterval(interval); active.delete(root); return; }
      const total = Math.max(0, Math.ceil((target - Date.now()) / 1000));
      if (!total) {
        digits.hidden = true;
        summary.textContent = '';
        status.textContent = 'The launch countdown has ended. Check the release for current availability.';
        clearInterval(interval);
        return;
      }
      digits.hidden = false;
      const parts = {days:Math.floor(total/86400),hours:Math.floor(total/3600)%24,minutes:Math.floor(total/60)%60,seconds:total%60};
      Object.entries(parts).forEach(([key,value]) => {root.querySelector(`[data-${key}]`).textContent = String(value).padStart(2,'0');});
      const minute = Math.floor(total/60);
      if (minute !== lastMinute) {
        summary.textContent = `${parts.days} days, ${parts.hours} hours and ${parts.minutes} minutes until launch.`;
        lastMinute = minute;
      }
    };
    active.set(root, () => clearInterval(interval));
    tick();
    if (target > Date.now()) interval = setInterval(tick,1000);
  });
  initialize();
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
  document.addEventListener('shopify:section:unload',event=>{
    for (const [root,stop] of active) if(event.target.contains(root)){stop();active.delete(root);}
  });
})();
